import fetchAPI from '../fetchAPI';

export interface ExtensionReportItem {
  id: string;
  reportId: string;
  userId: string;
  timestamp: string;
  extensionVersion: string;
  sessionStart: string;
  environment: {
    userAgent: string;
    url: string;
    platform: string;
  };
  summary: {
    totalErrors: number;
    byCategory: Record<string, number>;
    firstError: string;
    lastError: string;
  };
  errors: Array<{
    category: string;
    label: string;
    timestamp: string;
    severity: string;
    data?: Record<string, unknown>;
  }>;
  recentDetections: Array<{
    chatName: string;
    result: string;
    method: string;
    failureLabel?: string;
    timestamp: string;
  }>;
  totalErrors: number;
  primaryCategory: string;
  createdAt: string;
  /** 'manual' = sent from the extension's "Send diagnostics"; absent on older rows. */
  kind?: 'auto' | 'manual';
  /** Set on manual reports — opens the lookup screen. */
  referenceCode?: string | null;
  /** From `diagnostics.trigger`: 'cache-clear' on the report the extension
   *  sends just before clearing WhatsApp's cache; absent otherwise. */
  trigger?: string;
  /** Who sent it; null when the user row is gone. */
  user?: {
    id: string;
    name: string | null;
    email: string | null;
    companyName: string | null;
  } | null;
}

/** Why a report was sent, for the list's Trigger column and the lookup. */
export const reportTrigger = (item: { kind?: string; trigger?: string }): string =>
  item.trigger === 'cache-clear'
    ? 'Cache clear'
    : item.kind === 'manual'
      ? 'Sent by customer'
      : 'Error banner';

export interface ExtensionReportsResponse {
  data: ExtensionReportItem[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  pageCount: number;
  totalPageCount: number;
}

const callGetExtensionReports = async (
  page = 1,
  pageSize = 25,
  /** Matches the sender's name, email or company. */
  search?: string
): Promise<iResponse<ExtensionReportsResponse>> => {
  const qs =
    `page=${page}&pageSize=${pageSize}` + (search ? `&search=${encodeURIComponent(search)}` : '');
  return fetchAPI<ExtensionReportsResponse>({
    method: 'GET',
    route: `ext/report`,
    queryString: qs
  });
};

export default callGetExtensionReports;
